import {NormalizeByRange, Clamp} from "../../Utility/UtilityMethod.js";
export default class MouseAnimation {
  constructor(query, rotation_speed, isMobileDevice) {
    this.TouchVisibility = 0;
    this._touchVisibilityFadeTime = 2;
    this._touchVisibilityRecordTime = 0;
    this._isMobileDevice = false;
    this._svgDom = document.querySelector(query);
    this._svgImageDom = document.querySelector(query + " > img");
    this._rotation_speed = rotation_speed;
    this._isMobileDevice = isMobileDevice;
    this.TouchVisibility = !isMobileDevice ? 1 : 0;
  }
  OnUpdate(time) {
    if (!this._isMobileDevice)
      this._svgImageDom.style.transform = `rotate(${time * this._rotation_speed}rad)`;
    if (this._isMobileDevice && this._touchVisibilityRecordTime > 0) {
      this.TouchVisibility = 1 - NormalizeByRange(time, this._touchVisibilityRecordTime - this._touchVisibilityFadeTime, this._touchVisibilityRecordTime);
      this.TouchVisibility = Clamp(this.TouchVisibility, 0, 1);
    }
  }
  OnMouseMoveEvent(screen_x, screen_y) {
    if (!this._isMobileDevice)
      this._svgDom.style.transform = `translate(${screen_x}px, ${screen_y}px)`;
  }
  OnMouseDownEvent() {
    this.TouchVisibility = 1;
    this._touchVisibilityRecordTime = 0;
  }
  OnMouseUpEvent(time) {
    this.TouchVisibility = 1;
    this._touchVisibilityRecordTime = time + this._touchVisibilityFadeTime;
  }
}
